export const isMobile = () => {
  return window.matchMedia("(max-width: 767px)").matches;
};

export const maskAllButLast = (text) => {
  if (!text || text.length === 0) return "";
  return text.length > 1 ? "***" + text.slice(-1) : text;
};

export const interleaveArrays = (a, b) => {
  const result = [];
  const maxLength = Math.max(a.length, b.length);

  for (let i = 0; i < maxLength; i++) {
    if (i < a.length) result.push(a[i]);
    if (i < b.length) result.push(b[i]);
  }

  return result;
};



// WEBPACK FOOTER //
// ./src/utils/utils.js